// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 305 ? "96b8373f" : chunkId) + "." + {"305":"c539c0ba5a04f8d3","817":"4e2080a38340b641","845":"8115e6c5328c38b3"}[chunkId] + ".js";
};